//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';
import { MasterTeam } from 'common/models/internal/MasterTeam';

import { type AppState } from 'common/redux/reducers';
import { type WithRouterProps } from 'common/components/core/router';

class TeamMasterSelectors extends BaseEntitySelectors {
    constructor() {
        super('teamMaster');
    }

    getTeamMasterData = (
        state: AppState,
        props: { ...WithRouterProps }
    ): ?MasterTeam => {
        const clientId = clientIdSelector(state, props);
        const { teamMaster } = state;
        return teamMaster.getIn([
            'records',
            clientId,
            'entities',
            'Team',
            'entity'
        ]);
    };

    getTeamMasterIsLoading = (
        state: AppState,
        props: { ...WithRouterProps }
    ): ?boolean => {
        const clientId = clientIdSelector(state, props);
        const { teamMaster } = state;
        return teamMaster.getIn([
            'records',
            clientId,
            'entities',
            'Team',
            'isLoading'
        ]);
    };
}

export default new TeamMasterSelectors();
